/*
Monotype Foundry Platform API
Version 1.0.0

Definition: AccountTransferRequest

Properties:
  code: string (required)
  requestType: string (required)
  revisionId: string (required)
*/

var AccountTransferRequest = (function () {
  function validateAccountTransferRequest (arg) {
    // Validate code
    if (!arg.code) {
      throw new Error('AccountTransferRequest.code: Missing property')
    }
    if (arg.code && !(typeof arg.code === 'string')) {
      throw new Error('AccountTransferRequest.code: Wrong type: Got \'' + (typeof arg.code) + '\', but expected: \'string\'')
    }
    // Validate requestType
    if (!arg.requestType) {
      throw new Error('AccountTransferRequest.requestType: Missing property')
    }
    if (arg.requestType && !(typeof arg.requestType === 'string')) {
      throw new Error('AccountTransferRequest.requestType: Wrong type: Got \'' + (typeof arg.requestType) + '\', but expected: \'string\'')
    }
    // Validate revisionId
    if (!arg.revisionId) {
      throw new Error('AccountTransferRequest.revisionId: Missing property')
    }
    if (arg.revisionId && !(typeof arg.revisionId === 'string')) {
      throw new Error('AccountTransferRequest.revisionId: Wrong type: Got \'' + (typeof arg.revisionId) + '\', but expected: \'string\'')
    }
  }
  function buildAccountTransferRequest (arg) {
    var AccountTransferRequest = arg
    // Complete code
    // Expected Type: string
    AccountTransferRequest.code = AccountTransferRequest.code || ''
    // Complete requestType
    // Expected Type: string
    AccountTransferRequest.requestType = AccountTransferRequest.requestType || ''
    // Complete revisionId
    // Expected Type: string
    AccountTransferRequest.revisionId = AccountTransferRequest.revisionId || ''
    return AccountTransferRequest
  }
  return {
    validate: validateAccountTransferRequest,
    build: buildAccountTransferRequest
  }
})()

module.exports = AccountTransferRequest
